import { Box } from '@mui/material'
import { ReactComponent as PlusIcon } from 'assets/plan_edit_plus_logo.svg'
import { useState } from 'react'
import { COLORS } from 'styles/colors'

type ButtonFuncProps = {
	title: string
	onClick: () => void
	disabled?: boolean
	fullWidth?: boolean
}

const ButtonFunc = ({
	title,
	onClick,
	disabled = false,
	fullWidth = false,
}: ButtonFuncProps) => {
	const [hover, setHover] = useState(false)
	const iconStroke = disabled ? '#CFCFD4' : hover ? '#fff' : COLORS.main

	return (
		<Box
			onClick={disabled ? undefined : onClick}
			onMouseOver={() => setHover(true)}
			onMouseLeave={() => setHover(false)}
			component={'button'}
			disabled={disabled}
			sx={{
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				justifyContent: 'center',
				gap: '8px',
				backgroundColor: 'transparent',
				padding: '8px 16px',
				cursor: disabled ? 'not-allowed' : 'pointer',
				color: COLORS.main,
				height: '40px',
				width: fullWidth ? '100%' : 'auto',
				fontSize: '14px',
				fontFamily: 'Montserrat',
				fontWeight: '600',
				textTransform: 'none',
				border: `1px solid ${COLORS.main}`,
				borderRadius: '12px',
				...(!disabled && {
					transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
					'&:hover': {
						backgroundColor: COLORS.main,
						color: 'white',
						boxShadow: '0px 4px 16px rgba(82, 34, 208, 0.4)',
					},
				}),
				'&:active': {
					opacity: '0.9',
				},
				'&:disabled': {
					color: '#CFCFD4',
					backgroundColor: 'transparent',
					border: '1px solid #D9D9D9',
				},
			}}
		>
			<PlusIcon width='24px' height='24px' stroke={iconStroke} />
			{title}
		</Box>
	)
}

export default ButtonFunc
